export const GET_ROLES = "get_roles";
export const GET_ROLES_SUCCESS = "get_roles_success";
export const GET_ROLES_FAILURE = "get_roles_failure";
export const GET_CATALOG = "get_catalog";
export const GET_CATALOG_SUCCESS = "get_catalog_success";
export const GET_CATALOG_FAILURE = "get_catalog_failure";
export const RESET_RBAC = "reset_rbac";
